import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#0023a5',
            contrastText: '#ffffff',
        },
        complementary: {
            main: '#666666',
            contrastText: '#000000',
        },
        secondary: {
            main: '#ffffff',
            contrastText: '#0023a5',
        },
    },
    typography: {
        subtitle1: {
            fontSize: "1.25em"
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                /* Hide scrollbar arrows */
                "::-webkit-scrollbar-button": {
                    display: "none",
                    width: 0,
                    height: 0,
                },

                /* Firefox */
                html: {
                    scrollbarWidth: "thin",
                    scrollbarColor: "#c1c1c1 transparent",
                },

                /* Chrome, Edge, Safari */
                "::-webkit-scrollbar": {
                    width: "6px",
                    height: "6px",
                },
                "::-webkit-scrollbar-track": {
                    background: "transparent",
                },
                "::-webkit-scrollbar-thumb": {
                    backgroundColor: "#c1c1c1",
                    borderRadius: "8px",
                },
                "::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#a8a8a8",
                },
                'input::-webkit-search-cancel-button': {
                    display: 'none'
                },
                'input::-webkit-clear-button': {
                    display: 'none'
                },
            }
        },
    },
});

theme.components = {
    ...theme.components,
    MuiButton: {
        defaultProps: {
            disableElevation: true,
        },
        styleOverrides: {
            root: {
                textTransform: 'none',
                fontWeight: 400,
                fontSize: '1rem',
                transition: "background 0.25s, color 0.75s",
            },
            contained: {
                border: "1px solid",
                borderColor: "#0023a5",
                "&:hover": {
                    background: "transparent",
                    border: "1px solid",
                    borderColor: "#0023a5",
                    color: "#0023a5"
                }
            },
            containedSecondary: {
                border: "1px solid",
                borderColor: "#ffffff",
                "&:hover": {
                    background: "transparent",
                    border: "1px solid",
                    borderColor: "#ffffff",
                    color: "#ffffff"
                }
            },
            textPrimary: {
                color: theme.palette.primary.main,
                background: "#ffffff",
                padding: 0,
                "&:hover": {
                    textDecoration: "underline",
                    background: "#ffffff",
                }
            },
            textSecondary: {
                color: theme.palette.complementary.main,
                background: "#ffffff",
                padding: 0,
                "&:hover": {
                    textDecoration: "underline",
                    background: "#ffffff",
                }
            },
        },
        variants: [
            {
                props: { variant: 'paper' },
                style: ({ theme }) => ({
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                    borderRadius: theme.shape.borderRadius,
                    boxShadow: 'none',
                    border: `1px solid ${theme.palette.divider}`,
                    textTransform: 'none',

                    '&:hover': {
                        backgroundColor: "#F5F5F5",
                        boxShadow: 'none',
                    },

                    '&:active': {
                        boxShadow: 'none',
                    },
                }),
            }
        ]
    },
    MuiPaper: {
        defaultProps: {
            variant: "outlined",
        }
    },
    MuiToggleButton: {
        styleOverrides: {
            root: {
                textTransform: 'none',
                fontWeight: 400,
                fontSize: '1rem'
            },
        },
    },
    MuiTypography: {
        variants: [
            {
                props: { variant: 'complementary' },
                style: {
                    color: theme.palette.complementary.main,
                },
            },
        ],
    },
    MuiDialog: {
        styleOverrides: {
            paper: {
                /* This applies only to the Dialog's paper container */

                /* Firefox scrollbar */
                "& *": {
                    scrollbarWidth: "thin",
                    scrollbarColor: "#c1c1c1 transparent",
                },

                /* Chrome, Edge, Safari */
                "& *::-webkit-scrollbar": {
                    width: "6px",
                    height: "6px",
                },
                "& *::-webkit-scrollbar-track": {
                    background: "transparent",
                },
                "& *::-webkit-scrollbar-thumb": {
                    backgroundColor: "#c1c1c1",
                    borderRadius: "8px",
                },
                "& *::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#a8a8a8",
                },

                /* Remove arrows */
                "& *::-webkit-scrollbar-button": {
                    display: "none",
                    width: 0,
                    height: 0,
                },
            },
        },
    },
};

export default theme;